import React, { useState } from "react";
import { ThumbsUp, ThumbsDown } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { useCustomer } from "@/context/CustomerContext";

// "Did that solve it?" under Nick's latest answer — feeds the admin resolution rate.
export function SolvedPrompt({ msg, onRated }) {
  const { sessionId } = useCustomer();
  const [busy, setBusy] = useState(false);
  const rate = async (solved) => {
    setBusy(true);
    onRated(msg, solved, !solved);
    try {
      const { data } = await api.post("/chat/feedback", { session_id: sessionId, message_id: msg.message_id || msg.id, solved });
      onRated(msg, solved, data.offer_ticket);
    } catch { onRated(msg, null, false); } finally { setBusy(false); }
  };

  if (msg.customer_feedback === "up") {
    return <div className="mt-2 text-xs text-[#73bf44]" data-testid="solved-thanks">Glad that sorted it — thanks for letting us know!</div>;
  }
  if (msg.customer_feedback === "down") {
    return <div className="mt-2 text-xs text-neutral-400" data-testid="solved-sorry">Sorry that didn't sort it.</div>;
  }
  const btn = "inline-flex items-center gap-1.5 rounded-full border border-neutral-800 px-3 py-1.5 text-xs transition-colors disabled:opacity-50";
  return (
    <div className="mt-2 flex items-center gap-2" data-testid="solved-prompt">
      <span className="text-xs text-neutral-500 mr-1">Did that solve it?</span>
      <button disabled={busy} onClick={() => rate(true)} data-testid="solved-yes" className={`${btn} text-neutral-300 hover:border-[#73bf44]/60 hover:text-[#73bf44]`}>
        <ThumbsUp size={14} /> Yes
      </button>
      <button disabled={busy} onClick={() => rate(false)} data-testid="solved-no" className={`${btn} text-neutral-300 hover:border-amber-400/60 hover:text-amber-300`}>
        <ThumbsDown size={14} /> No
      </button>
    </div>
  );
}
